import * as yup from "yup";

const editDriverScheme = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  addressLine1: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  stateCode: yup.string().required("State is required"),
  userEmail: yup
    .string()
    .email("Invalid email id")
    .required("Email Id is required"),
  phoneNumber: yup
    .string()
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Invalid phone number"),
});

export default editDriverScheme;
